<template>
  <p v-html="text" />
</template>

<script>
import { mapState } from 'vuex'

const TEAM_SCORING_RULES = {
  AVERAGE: 'average',
  TOTAL: 'total',
  FASTEST: 'fastest',
}

export default {
  props: {
    teamScoringRule: {
      type: String,
      default: TEAM_SCORING_RULES.AVERAGE,
    },
    resultTeam: {
      type: Object,
      default: () => {},
    },
    resultSolo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      text: '',
    }
  },
  computed: {
    ...mapState({
      audienceId: (state) => state.audienceId,
      audienceQuizTeam: (state) => state.audienceQuizTeam,
      presentation: (state) => state.presentation,
    }),
    audienceTeamResponse() {
      if (this.resultTeam && this.resultSolo && !this.resultTeam.noData) {
        return this.resultTeam[this.audienceQuizTeam]
      }

      return {}
    },
  },
  watch: {
    audienceTeamResponse: {
      handler(value) {
        if (value && typeof value.totalPoint === 'number') {
          this.getText()
        }
      },
      immediate: true,
    },
  },
  methods: {
    getText() {
      switch (this.teamScoringRule) {
        case TEAM_SCORING_RULES.AVERAGE:
          this._getTextForAverageRule()
          break
        case TEAM_SCORING_RULES.TOTAL:
          this._getTextForTotalRule()
          break
        case TEAM_SCORING_RULES.FASTEST:
          this._getTextForFastestRule()
          break
        default:
      }
    },
    _getTextForAverageRule() {
      this.text = this.$t('teamEarnsPointAverage', {
        point: this.audienceTeamResponse.totalPoint,
      })
    },
    _getTextForTotalRule() {
      this.text = this.$t('teamEarnsPointTotal', {
        point: this.audienceTeamResponse.totalPoint,
      })
    },
    _getTextForFastestRule() {
      const areYouFastest = this.audienceTeamResponse.audience === this.audienceId

      if (areYouFastest) {
        this.text = this.$t('teamFastestAnswerGetPoint', {
          point: this.audienceTeamResponse.totalPoint,
        })
      } else {
        this.text = this.audienceTeamResponse.totalPoint > 0
          ? this.$t('teamEarnsPointFastest', {
            point: this.audienceTeamResponse.totalPoint,
            audienceName: this.audienceTeamResponse.audienceName,
          })
          : this.$t('teamFastestAnswerIncorrect', {
            point: 0,
          })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
p {
  color: #fff;
  font-size: 14px;
  line-height: 24px;
  margin-top: 4px;
}
</style>
